// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5D1xZ3F9","header":"_5DbhhFpk","main":"_5D3sCWOZ","description":"_5D3OdXlE","team-members":"_5D2lQw7T","title":"_5D1HyHH3","search":"_5D3qHKP6"};